import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import request from '@src/utils/request';
import { useRouteMatch } from 'react-router-dom';
import $$tracker from '@src/tracker';
class MainStore extends BaseStore {
  //页面数据
  @observable sections = [];

  @observable pageConfig = {};

  @observable allJobList = [];

  @observable filterAllJobList = [];

  /**
   * 职位列表
   */
  @observable jobList = [];

  /**
   * 招聘模式 social：社招 campus：校招
   */
  @observable mode = 'social';

  // @observable mode = 'campus';

  /**
   * 组织ID
   */
  // @observable orgId = 'xishanju-test';

  /**
   * 地址列表
   */
  @observable jobLocationList = [];

  @observable locationIds = [];
  /**
   * 职能
   */
  @observable jobzhinengList = [];

  /**
   * 搜索关键字
   */
  @observable keyword = '';

  // @observable commitment = [];

  @observable recruitmentType = [];

  @observable projectList = [];

  @observable projectId = [];

  @observable commitment = [];

  @observable commitmentId = [];

  @observable zhinengId = [];

  @observable departmentList = [];

  @observable departmentId = [];
  //总条数
  @observable total = 0;

  //分页用的每页条数
  @observable limit = 999;
  //分页用的每页条数
  @observable pageSize = 12;

  //分页用的偏移量，所示索引从0开始
  @observable offset = 0;

  @observable currentPage = 1;

  @observable zhinengFilterHide = false;

  @observable commitmenFilterHide = false;

  @observable departmentFilterHide = false;

  @observable locationFilterHide = false;

  @observable pageData;
  //招聘类型id
  @observable recruitmentId = [];

  hideFilter = type => {
    this[type] = !this[type];
  };

  onChangeSearch = value => {
    this.keyword = value;
  };
  clickSearch = () => {
    this.getJobList({ keyword: this.keyword });
  };

  onCommitmentChange = checkedValues => {
    this.commitmentId = checkedValues;
    this.getJobList();
  };

  onRecruitmentChange = checkedValues => {
    this.recruitmentId = checkedValues;
    this.getJobList();
  };

  onDepartmentChange = checkedValues => {
    this.departmentId = checkedValues;
    this.getJobList();
  };

  onzhinengChange = checkedValues => {
    this.zhinengId = checkedValues;
    this.getJobList();
  };

  onProjectChange = checkedValues => {
    this.projectId = checkedValues;
    this.getJobList();
  };

  onLocationChange = checkedValues => {
    this.locationIds = checkedValues.flat();
    this.getJobList();
  };

  onPageChange = pageNumber => {
    // console.log('Page: ', pageNumber);
    this.currentPage = pageNumber;
    // 计算起始和结束索引
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    // 使用 slice() 方法分割数组
    this.jobList = this.filterAllJobList.slice(startIndex, endIndex);
  };

  /**
   * 获取职位地址列表
   * @returns {Promise<void>}
   */
  getJobLocationList() {
    return request
      .get(`api/ssg_recruiting_cn/v1/api-platform/v1/jobs-groupedby-location/${this.orgId}`, { mode: this.mode })
      .then(res => {
        res.jobs.forEach(item => {
          item.value = item.locationRows.map(item => item.id);
          item.label = item.label;
        });

        this.jobLocationList = res.jobs;
      })
      .catch(error => {
        console.error('GET 请求失败', error);
      });
  }

  /**
   * 获取职位职能列表
   * @returns {Promise<void>}
   */
  getJobzhinengList() {
    return request
      .get(`api/ssg_recruiting_cn/v1/api-platform/v1/jobs-groupedby-zhineng/${this.orgId}`, { mode: this.mode })
      .then(res => {
        // console.log(res.jobs);
        res.jobs.forEach(item => (item.value = item.id ? item.id : 999999));
        this.jobzhinengList = res.jobs;

        if (this.$routeMatch.query.id) {
          this.checkZhinengIdParame();
        }

        // 如果找到了匹配的对象，则将其id存储到zhinengId数组中

        this.getJobList();
      })
      .catch(error => {
        console.error('GET 请求失败', error);
      });
  }

  // getJobList() {
  //   const queryParams = {
  //     mode: this.mode,
  //     offset: 0,
  //     limit: 99999,
  //     keyword: this.keyword ? this.keyword : undefined, // 如果 keyword 不为 null，则传递它
  //     locationIds: this.locationIds.length > 0 ? [...this.locationIds] : undefined // 如果 locationIds 是数组且不
  //   };

  //   if (this.locationIds.length > 0) {
  //     queryParams['locationIds'] = `[${this.locationIds.join(',')}]`;
  //   }

  //   return request
  //     .get(`api/ssg_recruiting_cn/v1/api-platform/v1/jobs/${this.orgId}`, {
  //       mode: this.mode,
  //       ...queryParams
  //     })
  //     .then(res => {
  //       this.total = res.total;
  //       this.allJobList = res.jobs;
  //       // console.log(res.jobs, '---------------------------------------');
  //       // return;
  //       this.filteringData();
  //     })
  //     .catch(error => {
  //       console.error('GET 请求失败', error);
  //     });
  // }
  getJobList() {
    const allJobs = []; // 用于存储所有的工作数据
    let total = 0; // 初始化总数据量

    // 定义一个递归函数来处理分页请求
    const fetchJobs = offset => {
      const queryParams = {
        mode: this.mode,
        offset: offset,
        limit: 100, // limit 只支持 100
        keyword: this.keyword ? this.keyword : undefined, // 如果 keyword 不为 null，则传递它
        locationIds: this.locationIds.length > 0 ? [...this.locationIds] : undefined // 如果 locationIds 是数组且不为空
      };

      if (this.locationIds.length > 0) {
        queryParams['locationIds'] = `[${this.locationIds.join(',')}]`;
      }

      return request
        .get(`api/ssg_recruiting_cn/v1/api-platform/v1/jobs/${this.orgId}`, {
          mode: this.mode,
          ...queryParams
        })
        .then(res => {
          total = res.total; // 更新总数据量
          allJobs.push(...res.jobs); // 将当前请求的工作数据添加到 allJobs 数组中

          // 如果已经获取到所有数据，则停止递归
          if (allJobs.length >= total) {
            // this.total = total;
            this.allJobList = allJobs;
            this.filteringData();
            return;
          }

          // 否则，继续下一页的请求
          return fetchJobs(offset + 100);
        })
        .catch(error => {
          console.error('GET 请求失败', error);
        });
    };

    // 从第一页开始请求
    return fetchJobs(0);
  }

  filteringData() {
    if (this.allJobList.length > 0) {
      // console.log([...this.allJobList]);
      // 工作部门
      const departmentFilter = this.departmentId;
      // 工作性质列表
      const commitmentFilter = this.commitmentId;

      const projectFilter = this.projectId;

      const recruitmentFilter = this.recruitmentId;

      const commitmentArray = Array.isArray(commitmentFilter) ? commitmentFilter : Array.from(commitmentFilter);
      const normalizedDepartmentFilter = departmentFilter?.map(item => item.trim().toLowerCase()) || [];
      const normalizedCommitmentFilter = commitmentArray.map(item => item.toLowerCase());
      const normalizedRecruitmentFilter = recruitmentFilter.map(item => item.toLowerCase());
      const normalizedProjectFilter = projectFilter.map(item => item);

      const zhinengFilter = this.zhinengId;

      const zhinengArray = Array.isArray(zhinengFilter) ? zhinengFilter : Array.from(zhinengFilter);
      const normalizedzhinengFilter = zhinengArray?.map(item => item) || [];

      const filteredJobs = this.allJobList.filter(job => {
        // console.log(job.customFields[0]);

        const jobDepartmentName = job.department.name.trim().toLowerCase();
        const jobCommitmentName = job.commitment.trim().toLowerCase();
        const jobzhinengId = job.zhineng.id;
        const jobRecruitmentId = job.customFields.filter(item => item.name === '招聘类型')[0]?.value;
        // const jobTitle = job.title;

        let jobTitle = job.customFields.filter(item => item.name === '项目')[0]?.value;
        // console.log(jobTitle, '-----------------------');
        if (jobTitle === undefined) {
          // console.log('未找到 name 为 "项目" 的自定义字段');
          // 你可以在这里添加其他处理逻辑，比如给 jobTitle 赋一个默认值
          jobTitle = '无项目信息';
        }

        const matchesDepartment = !normalizedDepartmentFilter.length || normalizedDepartmentFilter.includes(jobDepartmentName);
        const matchesCommitment = !normalizedCommitmentFilter.length || normalizedCommitmentFilter.includes(jobCommitmentName);

        const matchesRecruitment = !normalizedRecruitmentFilter.length || normalizedRecruitmentFilter.includes(jobRecruitmentId);

        // const matchesProject = !normalizedProjectFilter.length || normalizedProjectFilter.includes(jobTitle);

        const matchesProject = !normalizedProjectFilter.length || normalizedProjectFilter.some(item => jobTitle.indexOf(item) >= 0);

        const matchesZhineng = !normalizedzhinengFilter.length || normalizedzhinengFilter.includes(jobzhinengId);
        return matchesDepartment && matchesCommitment && matchesZhineng && matchesRecruitment && matchesProject;
      });

      this.filterAllJobList = this.filterJobsWithUniqueIds(filteredJobs.length > 0 ? filteredJobs : []);
      this.onPageChange(1);
      this.total = this.filterAllJobList.length;
    } else {
      this.filterAllJobList = [];
      this.total = this.filterAllJobList.length;
      this.onPageChange(1);
    }
  }

  filterJobsWithUniqueIds = jobs => {
    const idSet = new Set();
    return jobs?.filter(({ id }) => !idSet.has(id) && idSet.add(id));
  };

  clickJob(item) {
    if (DEPLOY_ENV === 'master' || DEPLOY_ENV === 'test') {
      const url = this.mode === 'social' ? 'jobArticle.html' : 'campusArticle.html';
      this.jumpPage(url, `#/?jobId=${item.id}&prior=${item.prior}`);
    } else {
      this.redirect(`jobArticle?jobId=${item.id}&prior=${item.prior}`);
    }
    // if (DEPLOY_ENV === 'master') {
    //   const url = this.mode === 'social' ? 'jobArticle.html' : 'campusArticle.html';
    //   const currentUrl = new URL(window.location.href);
    //   currentUrl.hash = '';
    //   let newUrlString = currentUrl.toString().replace('jobList.html', url);
    //   newUrlString += `#/?jobId=${item.id}&prior=${item.prior}`;
    //   window.location.href = newUrlString;
    // } else {
    //   this.redirect(`jobArticle?jobId=${item.id}&prior=${item.prior}`);
    // }
  }

  checkProjectParame() {
    const project = this.$routeMatch.query.project;
    // 初始化一个空数组来存储匹配项的 label
    const matchingLabels = [];

    // 检查 project 是否存在且包含逗号
    if (project && project.includes(',')) {
      // 如果包含逗号，将其按逗号分割成数组
      const projectArray = project.split(',');
      // 遍历分割后的数组
      projectArray.forEach(projectValue => {
        // 为每个值查找匹配项
        const matchingItem = this.projectList.find(item => projectValue.indexOf(item.label) >= 0);
        if (matchingItem) {
          // 如果找到匹配项，将其 label 添加到 matchingLabels 数组中
          matchingLabels.push(matchingItem.label);
        }
      });
    } else {
      // 如果不包含逗号，直接查找匹配项
      const matchingItem = this.projectList.find(item => project && project.indexOf(item.label) >= 0);
      if (matchingItem) {
        // 如果找到匹配项，将其 label 添加到 matchingLabels 数组中
        matchingLabels.push(matchingItem.label);
      }
    }

    // 将匹配项的 label 数组赋值给 this.projectId
    if (matchingLabels.length > 0) {
      this.projectId = matchingLabels;
    }
    this.redirect('/', true);
  }

  checkZhinengIdParame() {
    if (this.$routeMatch.query.id) {
      const idStr = this.$routeMatch.query.id;
      // 初始化一个空数组来存储匹配项的 id
      const matchingIds = [];

      // 检查 idStr 是否包含逗号
      if (idStr.includes(',')) {
        // 如果包含逗号，将其按逗号分割成数组
        const idArray = idStr.split(',');
        // 遍历分割后的数组
        idArray.forEach(idValue => {
          const id = Number(idValue);
          // 为每个值查找匹配项
          const matchingItem = this.jobzhinengList.find(item => item.id === id);
          if (matchingItem) {
            // 如果找到匹配项，将其 id 添加到 matchingIds 数组中
            matchingIds.push(matchingItem.id);
          }
        });
      } else {
        const id = Number(idStr);
        // 直接查找匹配项
        const matchingItem = this.jobzhinengList.find(item => item.id === id);
        if (matchingItem) {
          // 如果找到匹配项，将其 id 添加到 matchingIds 数组中
          matchingIds.push(matchingItem.id);
        }
      }

      // 将匹配项的 id 数组赋值给 this.zhinengId
      if (matchingIds.length > 0) {
        this.zhinengId = matchingIds;
      }

      this.redirect('/', true);
    }
  }

  use() {
    super.use();
    this.$routeMatch = useRouteMatch();
    useMount(async () => {
      $$tracker.loadPageLbjz();
      // console.log([...this.projectId]);
      // console.log('componentDidMount');

      window.__FUN_LINK_PAGE_DATA_PROMISE__.then(res => {
        const { data, status } = res;
        // console.log('data', data.pageConfig);
        // console.log(data);
        this.pageConfig = data.pageConfig;
        this.mode = data.modeConfig.mode;
        this.sections = data.sections;

        data.projectTypeList.forEach(item => {
          item.value = item.label;
        });
        data.recruitmentTypeList.forEach(item => {
          item.value = item.label;
        });
        this.projectList = data.projectTypeList;
        this.recruitmentType = data.recruitmentTypeList;
        if (this.$routeMatch.query.project && this.mode === 'campus') {
          this.checkProjectParame();
          // const project = this.$routeMatch.query.project;
          // console.log(project);
          // console.log([...this.projectList]);
          // const matchingItem = this.projectList.find(item => project.indexOf(item.label) >= 0);
          // if (matchingItem) {
          //   this.projectId = [matchingItem.label];
          // }
        }
        this.getJobLocationList();
        this.getJobzhinengList();
        // this.getJobList();
      });
    });
  }
}

export default MainStore;
